import { render, staticRenderFns } from "./RegisterWizard.vue?vue&type=template&id=39375372&scoped=true"
import script from "./RegisterWizard.vue?vue&type=script&lang=js"
export * from "./RegisterWizard.vue?vue&type=script&lang=js"
import style0 from "./RegisterWizard.vue?vue&type=style&index=0&id=39375372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39375372",
  null
  
)

export default component.exports